import { useMemo } from 'react'
import { styled } from '@mui/material/styles'
import { List, Typography } from '@mui/material'
import {
  ContactIcon,
  SupportIcon,
  BookmarkIcon,
  SettingsIcon,
  PrivacyTipIcon,
  InviteFreindsIcon,
  QuestionOutlinedIcon,
  ChartArcIcon,
} from '@weblite/icons'
import { ProfileActionItem } from '$common/profile-action-item'
import {
  openContacts,
  openFAQ,
  openPrivacyPolicy,
  openSettings,
} from '$logic/router'
import { getPrivateSpace } from '$logic/private-space'
import { openRoom } from '$logic/opened-room'
import { shareText } from '$helper/functions/share-api'
import { useUserIsStudent } from '$logic/profile/react-hook'
import { openSupport } from '$func/open-support'
import { usePackagesStats } from '$logic/premium-features'
import { openUsageDashboard } from '$logic/wapps/business'
import { toLocale } from '$helper/functions/text'
import { t } from '$i18n'
import { IS_IN_ALPHA_SCHOOL } from '$setup/config/env'

const invitationIsEnabled = import.meta.env.VITE_HAS_INVITATION === 'true'

const DashboardItemTextContainer = styled('div')`
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
`

const ActionItemBadgeContainer = styled('div')`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme }) => theme.palette.error500};
`

export function MyAccountActions() {
  const endingPackagesCount = usePackagesStats()?.endingPackagesCount

  const onDashboardClick = () => {
    openUsageDashboard()
    analite('PROFILE_DASHBOARD_CLICK')
  }

  const onSupportClick = () => {
    analite('PROFILE_SUPPORT_CLICK')
    openSupport()
  }

  const onSavedMessageClick = () => {
    openRoom(getPrivateSpace()?.roomId)
    analite('PROFILE_SAVED_CLICK')
  }

  const onContactsClick = () => {
    analite('PROFIE_CONTACTS_CLICK')
    openContacts()
  }
  const onPrivacyClick = () => {
    analite('PROFILE_PRIVACY_CLICK')
    openPrivacyPolicy()
  }

  const isStudent = useUserIsStudent()
  const { shareable: canInviteFriends, onShare: inviteFriends } = useMemo(
    () =>
      shareText(
        isStudent ? t('invite.inviteStudent') : t('invite.inviteTeacher'),
      ),
    [isStudent],
  )
  const onInviteClick = async () => {
    analite('PROFILE_INVITE_CLICK')
    inviteFriends?.()
  }

  return (
    <StyledList>
      {/* {!IS_IN_ALPHA_SCHOOL && (
        <ProfileActionItem
          iconBgColor="secondary500"
          Icon={<ChartArcIcon />}
          onClick={onDashboardClick}
        >
          <DashboardItemTextContainer>
            {t('myAccount.usageDashboard')}

            {!!endingPackagesCount && (
              <ActionItemBadgeContainer>
                <Typography variant="subtitle3" color="white">
                  {toLocale(endingPackagesCount)}
                </Typography>
              </ActionItemBadgeContainer>
            )}
          </DashboardItemTextContainer>
        </ProfileActionItem>
      )} */}

      {/* {!IS_IN_ALPHA_SCHOOL && (
        <ProfileActionItem
          iconBgColor="yellow700"
          Icon={<ContactIcon />}
          onClick={onContactsClick}
        >
          {t('myAccount.contact')}
        </ProfileActionItem>
      )} */}

      <ProfileActionItem
        iconBgColor="primary500"
        Icon={<BookmarkIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onSavedMessageClick}
      >
        {t('myAccount.savedMessage')}
      </ProfileActionItem>

      <ProfileActionItem
        iconBgColor="neutral600"
        Icon={<SettingsIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={openSettings}
      >
        {t('common.settings')}
      </ProfileActionItem>
      {/* <ProfileActionItem
        iconBgColor="success500"
        Icon={<SupportIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onSupportClick}
      >
        {t('myAccount.support')}
      </ProfileActionItem> */}

      {/* {import.meta.env.VITE_ENABLE_FAQ === 'true' && (
        <ProfileActionItem Icon={<QuestionOutlinedIcon />} onClick={openFAQ}>
          {t('myAccount.faq')}
        </ProfileActionItem>
      )} */}

      {/* {invitationIsEnabled && canInviteFriends && inviteFriends && (
        <ProfileActionItem
          iconBgColor="secondary500"
          Icon={<InviteFreindsIcon sx={{ width: '20px', height: '20px' }} />}
          onClick={onInviteClick}
        >
          {t('myAccount.inviteFriends')}
        </ProfileActionItem>
      )} */}

      {/* <ProfileActionItem
        iconBgColor="error500"
        Icon={<PrivacyTipIcon sx={{ width: '20px', height: '20px' }} />}
        onClick={onPrivacyClick}
      >
        {t('myAccount.privacyRules')}
      </ProfileActionItem> */}
    </StyledList>
  )
}

const StyledList = styled(List)(({ theme }) => ({
  backgroundColor: theme.palette.neutral000,
  boxShadow: theme.shadows[3],
  borderRadius: '12px',
  padding: 0,
  '& > li': {
    overflow: 'hidden',
  },
  '& > li:first-child': {
    borderRadius: '12px 12px 0 0',
  },
  '& > li:last-child': {
    borderRadius: '0 0 12px 12px',
  },
}))
